// extracted by mini-css-extract-plugin
export default {"wrap":"PageWrap_wrap__MwkTK","noBottomPadding":"PageWrap_noBottomPadding__jy9AC"};